import React from "react";
import { IMAGES, COMPANY } from "@/lib/content";

// Header logo — full color on white header background.
export const Logo = ({ size = "md", className = "" }) => {
  const dims = {
    sm: "h-10 w-10",
    md: "h-16 w-16",
    lg: "h-20 w-20",
    xl: "h-24 w-24",
  }[size];

  const panelPad = {
    sm: "p-1.5",
    md: "p-2",
    lg: "p-2.5",
    xl: "p-3",
  }[size];

  return (
    <div className={`flex items-center ${className}`} data-testid="abayle-logo">
      <div className={`bg-white rounded-md ${panelPad}`}>
        <img
          src={IMAGES.logo}
          alt={COMPANY.name}
          className={`${dims} object-contain block`}
          draggable="false"
        />
      </div>
    </div>
  );
};

// Footer logo — rendered as a pure white monochrome mark directly on the
// dark green footer background. No white plate, no card, no container —
// only the logo artwork itself in white with full transparency around it.
//
// Technique: CSS filter chain converts colored artwork + white background
// JPEG into grayscale/inverted, then `mix-blend-mode: screen` against the
// dark green footer multiplies out the dark-inverted-white area so ONLY the
// white logo silhouette remains, as if it were a transparent white PNG.
export const FooterLogo = () => {
  return (
    <div className="inline-flex items-center" data-testid="footer-logo">
      <img
        src={IMAGES.logo}
        alt={COMPANY.name}
        draggable="false"
        className="h-16 w-16 sm:h-20 sm:w-20 object-contain block select-none"
        style={{
          // Convert all visible logo artwork (green + gold) into clean white,
          // knock out the white JPEG background so the footer shows through.
          filter:
            "invert(1) grayscale(1) brightness(2) contrast(1.15)",
          mixBlendMode: "screen",
        }}
      />
    </div>
  );
};

export default Logo;
